import React, { useEffect, useRef } from "react";

const testimonials = [
  {
    name: "Diana Gómez",
    event: "Cumpleaños infantil",
    text: "La verdad, sin palabras. Fue mucho más de lo que esperaba. La atención y el servicio fueron inmejorables, súper atentas todas las chicas, la animadora Ornella una genia y el salón estaba hermoso, limpio y muy bien ambientado. Sin dudas los volvería a elegir para el próximo cumple.",
    stars: 5,
    initial: "D",
  },
  {
    name: "Bárbara Alejandra Sarmiento",
    event: "Cumpleaños infantil",
    text: "Excelente atención y animación. No nos quedan más que palabras de agradecimiento, la pasamos súper. Las chicas son lo más, muy atentas desde antes hasta después del cumple. El servicio de fotografía también es espectacular. Simplemente los mejores.",
    stars: 5,
    initial: "B",
  },
  {
    name: "Antonella Pulgar",
    event: "Cumpleaños infantil",
    text: "Fui al salón con mi hijo y quedamos encantados. Todo súper limpio, los juegos en perfecto estado y las encargadas con una buena onda tremenda, atentas a todo con los chicos. Mi hijo no quería irse.",
    stars: 5,
    initial: "A",
  },
];

export default function Testimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".reveal").forEach((el) => {
              el.classList.add("visible");
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="testimonios"
      ref={sectionRef}
      className="py-24 bg-primary relative overflow-hidden"
      aria-labelledby="testimonios-title"
    >
      {/* Decorative large quote */}
      <div
        className="absolute top-8 left-8 font-display text-white/5 pointer-events-none select-none"
        style={{ fontSize: "20rem", lineHeight: 1 }}
        aria-hidden="true"
      >
        "
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-4 reveal">
          <p className="font-accent text-gold-light text-2xl mb-3">Lo que dicen nuestros clientes</p>
          <h2
            id="testimonios-title"
            className="font-display text-4xl md:text-5xl font-bold text-white leading-tight mb-4"
          >
            Opiniones de clientes
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className="reveal bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300"
              style={{ transitionDelay: `${i * 100}ms` }}
              aria-labelledby={`testimonial-${i}-name`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                <span className="sr-only">{t.stars} de 5 estrellas</span>
                {[...Array(t.stars)].map((_, si) => (
                  <svg
                    key={si}
                    className="w-4 h-4 text-gold-light"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <blockquote>
                <p className="font-body text-white/85 text-sm leading-relaxed mb-4 italic">
                  "{t.text}"
                </p>
              </blockquote>

              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full bg-gold-gradient flex items-center justify-center shadow-gold shrink-0">
                  <span className="font-display font-bold text-white">{t.initial}</span>
                </div>
                <div>
                  <p id={`testimonial-${i}-name`} className="font-body font-semibold text-white text-sm">
                    {t.name}
                  </p>
                  <p className="font-body text-white/50 text-xs">{t.event}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Social links */}
        <div className="text-center mt-12 reveal">
          <p className="font-body text-white/60 mb-4 text-sm">
            ¿Querés ver más reseñas? Seguinos en nuestras redes
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://www.instagram.com/magic_kingdom_eventos"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-body text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-300"
              aria-label="Ver Magic Kingdom Eventos en Instagram"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              Instagram
            </a>
            <a
              href="https://www.facebook.com/share/1DfqZw8kzD/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-body text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-300"
              aria-label="Ver Magic Kingdom Eventos en Facebook"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
              Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
